import React, { Fragment } from 'react'

import { Helmet } from 'react-helmet'

import Navbar from '../components/navbar'
import Footer from '../components/footer'
import './icharge-platform.css'

const IchargePlatform = (props) => {
  return (
    <div className="icharge-platform-container1">
      <Helmet>
        <title>IchargePlatform - Copy of iCharge web copy 2</title>
        <meta
          property="og:title"
          content="IchargePlatform - Copy of iCharge web copy 2"
        />
        <meta
          property="og:image"
          content="https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/d8d38ac4-4f3e-47be-9087-cfeb299d0f93/a5b67eda-b5fa-4da5-98e7-80a54823e21a?org_if_sml=1&amp;force_format=original"
        />
      </Helmet>
      <Navbar
        homeLink1={
          <Fragment>
            <span className="icharge-platform-text10">
              View real-time charger availability, monitor your charging
              sessions, and more
            </span>
          </Fragment>
        }
        homeLink2={
          <Fragment>
            <span className="icharge-platform-text11">
              Discover one of the nation&apos;s largest public fast charging
              networks, powered by 100% renewable energy
            </span>
          </Fragment>
        }
        homeLink3={
          <Fragment>
            <span className="icharge-platform-text12">How to Charge</span>
          </Fragment>
        }
        homeLink4={
          <Fragment>
            <span className="icharge-platform-text13">
              Learn how to power up on the go and review our charging FAQs.
            </span>
          </Fragment>
        }
        homeLink5={
          <Fragment>
            <span className="icharge-platform-text14">
              Can&apos;t find what you&apos;re looking for? Let us help you.
            </span>
          </Fragment>
        }
        aboutLink1={
          <Fragment>
            <span className="icharge-platform-text15">
              From recycling to renewable energy, we&apos;re committed to
              protecting our environment.
            </span>
          </Fragment>
        }
        aboutLink2={
          <Fragment>
            <span className="icharge-platform-text16">
              Cultivating Connection
            </span>
          </Fragment>
        }
        supportLink1={
          <Fragment>
            <span className="icharge-platform-text17">
              <span>
                Whether you&apos;re a dedicated public charger or want to keep
                your options open,
              </span>
              <br></br>
              <span> iCharge has a plan for you.</span>
            </span>
          </Fragment>
        }
        supportLink2={
          <Fragment>
            <span className="icharge-platform-text21">How to charge</span>
          </Fragment>
        }
        rootClassName="navbarroot-class-name10"
        chargingPointLink1={
          <Fragment>
            <span className="icharge-platform-text22">
              Can&apos;t find what you&apos;re looking for? Let us help you
            </span>
          </Fragment>
        }
        chargingPointLink2={
          <Fragment>
            <span className="icharge-platform-text23">
              Locate nearby charging points with the iCharge app and simplify
              your charging
            </span>
          </Fragment>
        }
      ></Navbar>
      <main className="icharge-platform-main column align-center full-vertical-height justify-center full-width">
        <h1 className="icharge-platform-text24 heading-1">iCharge Platform</h1>
        <section className="icharge-platform-service1 column align-center justify-center full-width thq-section-padding">
          <div className="icharge-platform-max-width1 row full-width max-content-width">
            <div className="icharge-platform-content1 column gap-5">
              <div className="column gap-5">
                <h2 className="icharge-platform-text25 heading-2">
                  Manage charging. Move with energy.
                </h2>
                <p className="icharge-platform-text26 sub-heading-2">
                  {' '}
                  The iCharge platform gives you full control over your electric
                  vehicle charging network. Monitor each station in real-time,
                  manage users and pricing, and make informed decisions with
                  detailed analytics—all from a single dashboard designed for
                  maximum efficiency.
                </p>
              </div>
            </div>
            <div className="icharge-platform-container3">
              <img
                alt="pastedImage"
                sizes="(min-width: 992px) 1200px, (min-width: 768px) 800px, 480px"
                src="/Pages/Home/mockup%204-1500w.webp"
                srcSet="/Pages/Home//mockup%204-1500w.webp 1200w, /Pages/Home/mockup%204-tablet.webp 800w, /Pages/Home/mockup%204-mobile.webp 480w"
                className="icharge-platform-pasted-image1"
              />
            </div>
          </div>
        </section>
        <section className="icharge-platform-service2 column align-center justify-center full-width thq-section-padding">
          <div className="icharge-platform-max-width2 row full-width max-content-width">
            <div className="icharge-platform-content2 column gap-5">
              <div className="column gap-5">
                <h2 className="icharge-platform-text27 heading-2">
                  Your Dashboard. Your Network.
                </h2>
                <p className="icharge-platform-text28 sub-heading-2">
                  <span className="icharge-platform-text29">
                    Every station, session, and click—under your watch.
                    Instantly see if a station is active, charging, or offline.
                    Identify technical issues and track performance with daily,
                    weekly, or monthly statistics.
                  </span>
                  <br></br>
                </p>
              </div>
            </div>
            <div className="icharge-platform-container5">
              <img
                alt="pastedImage"
                src="/Pages/Platform/mockup%205.svg"
                className="icharge-platform-pasted-image2"
              />
            </div>
          </div>
        </section>
        <section className="icharge-platform-service3 column align-center justify-center full-width thq-section-padding">
          <div className="icharge-platform-max-width3 row full-width max-content-width">
            <div className="icharge-platform-content3 column gap-5">
              <div className="column gap-5 icharge-platform-container6">
                <h2 className="icharge-platform-text31 heading-2">
                  Simplified Control, Smarter Decisions
                </h2>
                <p className="icharge-platform-text32 sub-heading-2">
                  Start or stop charging sessions, set custom rates, and manage
                  your network with ease. Intelligent reports give clear
                  insights, exportable to Excel or PDF, or sent automatically
                  via email. Managing your network has never been easier.
                </p>
              </div>
            </div>
            <div className="icharge-platform-container7">
              <video
                src="/Pages/Platform/mockup%20video.mp4"
                loop="true"
                muted="true"
                poster="https://play.teleporthq.io/static/svg/videoposter.svg"
                autoPlay="true"
                playsInline="true"
                className="icharge-platform-video"
              ></video>
            </div>
          </div>
        </section>
      </main>
      <Footer rootClassName="footerroot-class-name11"></Footer>
    </div>
  )
}

export default IchargePlatform
